import { RequestCurrency } from "../services/AutomaticProductService"

export type Currency = "euro" | "EURO" | "usd" | "USD" | "pound" | "POUND"

export type CurrencyMapper<T> = Record<Currency, T>

export const currencyToSymbolMapper: CurrencyMapper<string> = {
    "euro": "€",
    "EURO": "€",
    "usd": "$",
    "USD": "$",
    "pound": "£",
    "POUND": "£",
}

export const currencyToRequestCurrencyMapper: Record<Currency, RequestCurrency> = {
    "euro": "EURO",
    "EURO": "EURO",
    "usd": "USD",
    "USD": "USD",
    "pound": "POUND",
    "POUND": "POUND",
}
